/**
 * Static atlaskit light-theme token hex values for server-side SVG export.
 *
 * AUTO-GENERATED — do not edit manually.
 * Run: yarn node -r esbuild-register tools/generate-static-token-values.ts
 *
 * Source: @atlaskit/tokens/artifacts/token-default-values
 * These are the default (light-theme) hex values for atlaskit design tokens.
 * Used to seed the token cache in get-color-value.ts when running server-side
 * (svgdom / Node.js) where CSS custom properties are not available.
 */
export const staticAtlaskitTokenValues: Record<string, string> = {
  'color.background.input': '#FFFFFF',
  'color.background.accent.blue.subtlest': '#E9F2FE',
  'color.background.accent.red.subtlest': '#FFECEB',
  'color.background.accent.green.subtlest': '#DCFFF1',
  'color.background.accent.yellow.subtlest': '#FEF7C8',
  'color.background.accent.purple.subtlest': '#F8EEFE',
  'color.background.accent.teal.subtlest': '#E7F9FF',
  'color.background.accent.orange.subtlest': '#FFF5DB',
  'color.background.accent.magenta.subtlest': '#FFECF8',
  'color.background.accent.lime.subtlest': '#EFFFD6',
  'color.background.accent.gray.subtlest': '#F0F1F2',
  'color.background.accent.blue.subtler': '#CFE1FD',
  'color.background.accent.red.subtler': '#FFD5D2',
  'color.background.accent.green.subtler': '#BAF3DB',
  'color.background.accent.green.subtlest.hovered': '#BAF3DB',
  'color.background.accent.yellow.subtler': '#F5E989',
  'color.background.accent.purple.subtler': '#EED7FC',
  'color.background.accent.teal.subtler': '#C6EDFB',
  'color.background.accent.teal.subtlest.hovered': '#C6EDFB',
  'color.background.accent.orange.subtler': '#FCE4A6',
  'color.background.accent.magenta.subtler': '#FDD0EC',
  'color.background.accent.lime.subtler': '#D3F1A7',
  'color.background.accent.lime.subtlest.hovered': '#D3F1A7',
  'color.background.accent.gray.subtler.hovered': '#B7B9BE',
  'color.background.accent.blue.subtlest.pressed': '#ADCBFB',
  'color.background.accent.red.subtlest.pressed': '#FFB8B2',
  'color.background.accent.green.subtlest.pressed': '#97EDC9',
  'color.background.accent.yellow.subtlest.pressed': '#EFDD4E',
  'color.background.accent.purple.subtlest.pressed': '#E3BDFA',
  'color.background.accent.teal.subtlest.pressed': '#B1E4F7',
  'color.background.accent.orange.subtlest.pressed': '#FBD779',
  'color.background.accent.magenta.subtlest.pressed': '#FCB6E1',
  'color.background.accent.lime.subtlest.pressed': '#BDE97C',
  'elevation.surface': '#FFFFFF',
  'color.icon.accent.gray': '#7D818A',
  'color.icon.accent.blue': '#357DE8',
  'color.icon.accent.purple': '#AF59E1',
  'color.icon.accent.magenta': '#CD519D',
  'color.icon.accent.red': '#C9372C',
  'color.icon.accent.orange': '#E06C00',
  'color.border.accent.yellow': '#B38600',
  'color.icon.accent.lime': '#6A9A23',
  'color.icon.accent.green': '#22A06B',
  'color.icon.accent.teal': '#2898BD',
  'color.text': '#292A2E',
  'color.text.accent.blue': '#1558BC',
  'color.text.accent.purple': '#803FA5',
  'color.text.accent.magenta': '#943D73',
  'color.text.accent.red': '#AE2E24',
  'color.text.accent.orange': '#9E4C00',
  'color.text.accent.yellow': '#7F5F01',
  'color.text.accent.lime': '#4C6B1F',
  'color.text.accent.green': '#216E4E',
  'color.text.accent.teal': '#206A83',
  'color.border.accent.gray': '#7D818A',
  'color.border.accent.blue': '#357DE8',
  'color.border.accent.purple': '#AF59E1',
  'color.border.accent.magenta': '#CD519D',
  'color.border.accent.red': '#E2483D',
  'color.border.accent.orange': '#E06C00',
  'color.border.accent.lime': '#6A9A23',
  'color.border.accent.green': '#22A06B',
  'color.border.accent.teal': '#2898BD',
};
